import { Mail, Phone, User, X } from "lucide-react";

export default function ContactModal({ contact, onClose, title = "Contact", subtitle }) {
  return (
    <div
      data-testid="contact-modal"
      className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm grid place-items-center p-4"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md bg-neutral-950 border border-neutral-800"
      >
        <div className="flex items-center justify-between border-b border-neutral-800 px-6 py-4">
          <div>
            <div className="text-amber-500 text-xs font-bold tracking-[0.3em] uppercase">{title}</div>
            {subtitle && <div className="text-sm text-neutral-400 mt-1 truncate">{subtitle}</div>}
          </div>
          <button data-testid="contact-modal-close" onClick={onClose} className="text-neutral-400 hover:text-amber-500 p-2 -mr-2" aria-label="Close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <Row icon={<User className="w-4 h-4 text-amber-500" />} label="Name" value={contact.contact_name} testid="contact-name" />
          <Row
            icon={<Mail className="w-4 h-4 text-amber-500" />}
            label="Email"
            value={contact.contact_email}
            href={`mailto:${contact.contact_email}`}
            testid="contact-email"
          />
          <Row
            icon={<Phone className="w-4 h-4 text-amber-500" />}
            label="Phone"
            value={contact.contact_phone || "Not provided"}
            href={contact.contact_phone ? `tel:${contact.contact_phone}` : null}
            testid="contact-phone"
          />
        </div>
        <div className="border-t border-neutral-800 px-6 py-4 text-xs text-neutral-500 uppercase tracking-widest">
          Direct contact · No agency fees
        </div>
      </div>
    </div>
  );
}

function Row({ icon, label, value, href, testid }) {
  return (
    <div className="flex items-start gap-3 border border-neutral-800 p-4">
      <div className="w-8 h-8 bg-neutral-900 border border-neutral-800 grid place-items-center shrink-0">{icon}</div>
      <div className="min-w-0 flex-1">
        <div className="text-[10px] uppercase tracking-widest text-neutral-500">{label}</div>
        {href ? (
          <a data-testid={testid} href={href} className="text-neutral-100 hover:text-amber-500 break-all font-bold">{value}</a>
        ) : (
          <div data-testid={testid} className="text-neutral-100 break-all font-bold">{value}</div>
        )}
      </div>
    </div>
  );
}
